import dayjs from 'dayjs'
import { timeAsDayjs } from 'utils/time'

export function deadlineInDays (deadline: string | undefined) {
  if (!deadline) return 0
  const convertedDeadline = timeAsDayjs(deadline, { applyTimezone: false }).format('YYYY-MM-DD')
  return dayjs(`${convertedDeadline}`).diff(timeAsDayjs(), 'days')
}
